import ByodAdapter from './byod';

export default class AggregateAdapter extends ByodAdapter {
  get headers() {
    return {
      ...super.headers,
      Accept: 'application/x.dataset+json',
    };
  }

  urlForQuery(query) {
    const { metricId } = query;
    delete query.metricId;
    return `${this.host}/${this.namespace}/metrics/${metricId}/aggregates`;
  }
}
